<template>
    <div class="new-game-detail-header">
      <div class="top-game-info">
        <div class="match flex-center" @click="goToMatchDetail">
          <img :src="match.icon" v-if="match.icon" />
          <div class="match-name overflow-text">{{ match.name }}</div>
          <van-icon name="play" color="#73767A" size="14" />
        </div>
        <div class="stage overflow-text">{{ match.groupName }} {{ game.roundDescription }}</div>
        <div class="game-info flex-center">
          <div class="team" v-if="game.type === 'game'">
            <img v-if="hasHomeIcon" :src="game.homeIcon" />
            <div
              class="team-name overflow-text-tow"
              :class="{ 'team-name--no-logo': !hasHomeIcon }"
            >{{ game.homeName }}</div>
          </div>
          <div class="status" v-if="game.type === 'game'">
             <div v-if="game.homeScore != -1 && game.awayScore != -1">
                <div class="score">
                  <span>{{ game.homeScore }}</span>
                  <span>:</span>
                  <span>{{ game.awayScore }}</span>
                </div>
                <span class="penalty-kick" v-if="game.sportType === '足球' && game.homePenalty != -1 && game.awayPenalty != -1">点球({{ game.homePenalty }}:{{ game.awayPenalty }})</span>
                <span class="game-status" v-else-if="game.gameEnd == 1">已完赛</span>
             </div>
              <!-- 未开始时：比赛名称 > 未开赛 -->
             <div v-else-if="game.gameNotBegin == 1">
              <span class="game-name" v-if="game.name">{{game.name}}</span>
              <span class="game-status" v-else>未开赛</span>
             </div>
            <!-- 开赛后未录入比分时：未录入比分 -->
             <div v-else-if="game.gameNotBegin == 0">
              <span class="game-status">未录入比分</span>
            </div>
          </div>
          <div class="status" v-else>
            <div class="game-name-activity">{{ game.name }}</div>
          </div>
          <div class="team" v-if="game.type === 'game'">
            <img v-if="hasAwayIcon" :src="game.awayIcon" />
            <div
              class="team-name overflow-text-tow"
              :class="{ 'team-name--no-logo': !hasAwayIcon }"
            >{{ game.awayName }}</div>
          </div>
        </div>
      </div>
      <div v-if="showStageTable" class="section bkt-stage-section">
        <div class="bkt-stage-table">
          <div class="bkt-row bkt-row--head" :style="stageGridStyle">
            <div class="bkt-cell bkt-cell--team">{{ stageTeamLabel }}</div>
            <div
              v-for="col in stageColumns"
              :key="'h-' + (col.id || col.name)"
              class="bkt-cell bkt-cell--score"
              :class="cellToneClass(col)"
            >
              {{ col.name }}
            </div>
          </div>
          <div class="bkt-row" :style="homeRowStyle">
            <div class="bkt-cell bkt-cell--team">
              <img v-if="hasHomeIcon" class="bkt-badge" :class="{ 'bkt-badge--round': isRacketSport }" :src="game.homeIcon" alt="">
              <span
                class="bkt-team-name overflow-text"
                :class="{ 'bkt-team-name--no-logo': !hasHomeIcon }"
              >{{ game.homeName }}</span>
            </div>
            <div
              v-for="col in stageColumns"
              :key="'hm-' + (col.id || col.name)"
              class="bkt-cell bkt-cell--score"
              :class="[cellToneClass(col), setScoreClass(col, 'home')]"
            >
              {{ formatStageScore(col.homeScore) }}
            </div>
          </div>
          <div class="bkt-row" :style="awayRowStyle">
            <div class="bkt-cell bkt-cell--team">
              <img v-if="hasAwayIcon" class="bkt-badge" :class="{ 'bkt-badge--round': isRacketSport }" :src="game.awayIcon" alt="">
              <span
                class="bkt-team-name overflow-text"
                :class="{ 'bkt-team-name--no-logo': !hasAwayIcon }"
              >{{ game.awayName }}</span>
            </div>
            <div
              v-for="col in stageColumns"
              :key="'aw-' + (col.id || col.name)"
              class="bkt-cell bkt-cell--score"
              :class="[cellToneClass(col), setScoreClass(col, 'away')]"
            >
              {{ formatStageScore(col.awayScore) }}
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    game: {
      type: Object,
      default: () => {}
    },
    match: {
      type: Object,
      default: () => {}
    },
    liveStatus: {
      type: Object,
      default: () => {}
    },
    stages: {
      type: Array,
      default: () => []
    },
    sportType: {
      type: String,
      default: ''
    }
  },
  computed: {
    /** 与是否展示队徽一致，用于无 logo 时放大队名 */
    hasHomeIcon() {
      const v = this.game && this.game.homeIcon
      if (v == null || v === '') return false
      const s = String(v).trim()
      return s.length > 0 && s !== 'null' && s !== 'undefined'
    },
    hasAwayIcon() {
      const v = this.game && this.game.awayIcon
      if (v == null || v === '') return false
      const s = String(v).trim()
      return s.length > 0 && s !== 'null' && s !== 'undefined'
    },
    resolvedSportType() {
      const st = this.sportType || (this.game && this.game.sportType) || ''
      return String(st).trim()
    },
    stageColumns() {
      return Array.isArray(this.stages) ? this.stages : []
    },
    isRacketSport() {
      return ['羽毛球', '乒乓球', '匹克球', '网球'].includes(this.resolvedSportType)
    },
    showStageTable() {
      const cols = this.stageColumns
      
      if (cols.length === 0) return false
      if (this.resolvedSportType === '篮球') return true      
      if (this.isRacketSport) {
        return cols.some(col => this.hasSetScore(col.homeScore) && this.hasSetScore(col.awayScore))
      }
      return false
    },
    stageTeamLabel() {
      return this.isRacketSport ? '' : '球队'
    },
    stageGridStyle() {
      const n = this.stageColumns.length || 1
      const colWidth = this.isRacketSport ? '40px' : '36px'
      return {
        gridTemplateColumns: `minmax(0, 1fr) repeat(${n}, ${colWidth})`,
      }
    },
    homeRowStyle() {
      return {
        ...this.stageGridStyle,
        background: this.isRacketSport ? '#FFFFFF' : '#ECF5FF',
      }
    },
    awayRowStyle() {
      return {
        ...this.stageGridStyle,
        background: this.isRacketSport ? '#ECF5FF' : '#D9ECFF',
      }
    },
  },
  methods: {
    hasSetScore(v) {
      if (v == null || v === '') return false
      const n = Number(v)
      return !Number.isNaN(n) && n > -1
    },
    formatStageScore(v) {
      if (!this.hasSetScore(v)) return '—'
      return v
    },
    cellToneClass(col) {
      const n = col && col.name
      if (n === 'OT') return 'bkt-tone--ot'
      if (n === '总分') return 'bkt-tone--total'
      return ''
    },
    setScoreClass(col, side) {
      if (!this.isRacketSport) return ''
      const home = col.homeScore
      const away = col.awayScore
      if (!this.hasSetScore(home) || !this.hasSetScore(away)) {
        return ''
      }
      if (Number(home) === Number(away)) return 'stage-score--lose'
      const score = side === 'home' ? Number(home) : Number(away)
      const other = side === 'home' ? Number(away) : Number(home)
      return score > other ? 'stage-score--win' : 'stage-score--lose'
    },
    goToMatchDetail() {
       this.$router.push({ path: `/new-match-detail/${this.match.unionMatchId}/home` })
    }
  },
};
</script>

<style scoped lang="scss">
.new-game-detail-header {
  background: linear-gradient(180deg, #e3eaf1 0%, #f8fbff 100%);
  box-sizing: border-box;
  .top-game-info{
    box-sizing: border-box;
    padding-top: 20px;
    height: 196px;
    display: flex;
    align-items: center;
    flex-direction: column;
    > * + * {
      margin-top: 12px;
    }
    .match{
      justify-content: center;
      box-sizing: border-box;
      width: fit-content;
      max-width: 230px;
      height: 24px;
      background: #B4C8DF;
      border-radius: 61px;
      padding: 0 6px;
      > * + * {
        margin-left: 6px;
      }
      img{
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        border-radius: 50%;
      }
      .match-name{
        font-size: 12px;
        color: #73767A;
        flex: 0 1 auto;
        min-width: 0;
        text-align: center;
      }
      ::v-deep(.van-icon) {
        flex-shrink: 0;
      }
    }
    .stage{
      width: fit-content;
      padding: 0 8px;
      max-width: 144px;
      height: 20px;
      line-height: 20px;
      background: #B4C8DF;
      border-radius: 10px;
      margin: 0 auto;
      font-size: 10px;
      color: #73767A;
      margin-top: 8px;
    }
    .game-info{
      padding-top: 10px;
      height: 80px;
      .status {
        margin-left: 12px;
        margin-right: 12px;
      }
      img{
        width: 50px;
        height: 50px;
        border-radius: 5px;
        margin-bottom: 10px;
      }
      .team{
        text-align: center;
        width: 80px;
        font-size: 13px;
        color: #303133;
        .team-name--no-logo {
          font-size: 18px;
          // font-weight: 600;
          // 两行
          -webkit-line-clamp: 2;
        }
      }
      .status{
        width: 100px;
        color: #1D2129;
        text-align: center;
        .game-name{
          font-size: 14px;
          font-weight: 500;
        }
        .game-name-activity{
          font-size: 20px;
          font-weight: 500;
          width: 200%;
          transform: translateX(-25%);
        }
        .game-status{
          font-size: 12px;
        }
        .penalty-kick{
          font-size: 14px;
        }
        .score{
          font-size: 28px;
          font-weight: 500;
        }
      }
    }
  }
  .bkt-stage-section {
    // padding: 0 12px 16px;
    box-sizing: border-box;
    width: 100%;
  }
  .bkt-stage-table {
    width: 100%;
    overflow: hidden;
    background: #fff;
    font-size: 12px;
    color: #303133;
  }
  .bkt-row {
    display: grid;
    align-items: center;
    min-height: 48px;
    padding: 0 10px;
    box-sizing: border-box;
    &--head {
      background: #D9ECFF;
      color: #909399;
      font-weight: 600;
    }
    &:not(.bkt-row--head) {
      border-top: 1px solid #f0f2f5;
    }
  }
  .bkt-cell {
    min-width: 0;
    padding: 6px 0;
    font-size: 12px;
    &--team {
      display: flex;
      align-items: center;
      text-align: left;
      > * + * {
        margin-left: 6px;
      }
    }
    &--score {
      text-align: center;
    }
  }
  .bkt-badge {
    width: 16px;
    height: 16px;
    border-radius: 2px;
    flex-shrink: 0;
    object-fit: cover;
    background: #ebedf0;
    &--round {
      border-radius: 50%;
    }
  }
  .bkt-team-name {
    min-width: 0;
    &--no-logo {
      font-size: 18px;
      font-weight: 600;
    }
  }
  .bkt-tone--ot {
    color: #909399;
  }
  .bkt-row--head .bkt-tone--ot {
    color: #a8abb2;
  }
  .bkt-tone--total {
    color: #303133 ;
    font-weight: 600;
  }
  .stage-score--win {
    color: #303133;
    font-weight: 600;
  }
  .stage-score--lose {
    color: #909399;
    font-weight: 400;
  }
}
</style>
